export const DEFAULT_TEXT_WIDTH = 600;
export const DEFAULT_NEW_TEXT_WIDTH = 200;
export const DEFAULT_FONT_SIZE = 48;
export const DEFAULT_LINE_HEIGHT = 1.2;
export const DEFAULT_LETTER_SPACING = 0;
// biome-ignore lint/style/noMagicNumbers: const name explains purpose
export const FONT_SIZE_PRESETS = [16, 32, 48, 64, 80, 96, 112, 128, 144, 160] as const;
